/** @file Checks that a name is valid for its kind and not used by another entity of that kind. */
import type { EntityKind, Id } from '@pose2d/format/types';
import { names } from '@pose2d/format/names';
import { throwError } from '@pose2d/format/throwError';
import type { CommandContext } from '../commandContext';

/** Throws INVALID_NAME or NAME_TAKEN (path `name`); `self` is the entity being renamed, which may keep its name. */
export function assertFreeName(ctx: CommandContext, kind: EntityKind, name: string, self?: Id): void {
  if (!names.isValid(kind, name)) throwError('INVALID_NAME', { name, kind }, { path: 'name' });
  const holder = ctx.index.byName.get(kind)?.get(name);
  if (holder !== undefined && holder !== self) throwError('NAME_TAKEN', { kind, name }, { path: 'name', hint: `rename ${holder} first or pick another name` });
}
